import React, { useEffect, useRef } from "react";
import "./DiwaliTheme.css";
import { Fireworks } from "fireworks-js";
import diyaImage from "../../assets/image/png/lamp.png";
import { color } from "framer-motion";

const DiwaliTheme = () => {
  const fireworksRef = useRef(null);

  useEffect(() => {
  const container = fireworksRef.current;

  const fireworks = new Fireworks(container, {
    autoresize: true,
    opacity: 0.25,
    acceleration: 1.03,
    friction: 0.98,
    gravity: 1.2,
    particles: 45,
    traceLength: 3,
    explosion: 3.5,
    intensity: 22,
    brightness: {
      min: 70,
      max: 95,
    },
    hue: {
      min: 35, // warm yellow range
      max: 55,
    },
  });

  fireworks.start();
  return () => fireworks.stop();
}, []);


  return (
    <>
      {/* Fireworks Background */}
      <div
        ref={fireworksRef}
        className="fireworks-container"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Floating diyas & banner */}
      <div className="diwali-overlay">
        <div className="diwali-banner">
          🪔✨ Happy Diwali from <strong>
            <span style={{ color: "#113C66" }}>Drone</span> <span style={{ color: "#328DCC" }}>Planet</span>
            </strong> ✨🪔
        </div>

        <div className="floating-diyas">
          {Array.from({ length: 10 }).map((_, i) => (
            <img
              key={i}
              src={diyaImage}
              alt="diya"
              className="diya-img"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${8 + Math.random() * 5}s`,
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default DiwaliTheme;
